import React, { useState, useEffect } from 'react';
import { Form, Input, Row, Col, Modal, Select, notification } from 'antd';
import 'antd/dist/antd.css';
import { useTranslation } from 'react-i18next';
import { Loading } from '../index';
import FormItem from 'antd/es/form/FormItem';
import { courierAssignments } from 'store/requests/order';
import { STATUS } from 'helpers/constants';

const { Option } = Select;
const ChangeOrderCourier = ({ onCloseHandler, orderId, couriers, getCourierLoading, onSuccessCallback }) => {
  const { t } = useTranslation();
  const id = orderId;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  console.log('getCourierLoading', getCourierLoading);
  const onFinish = async (values) => {
    setLoading(true);
    const payload = {
      orderId: values.orderId,
      courierId: values.courierId,
    };
    courierAssignments(payload)
      .then((data) => {
        if (data?.isSuccess) {
          notificationSave(STATUS.SUCCESS);
          onSuccessCallback();
        } else {
          notification[STATUS.ERROR]({
            description: data?.message,
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const notificationSave = (type) => {
    notification[type]({
      message: t('processCompleted'),
      description: t('courierChanged'),
    });
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <Modal
      centered
      open={true}
      maskClosable={false}
      onOk={() => form.submit()}
      okButtonProps={{ loading: loading || getCourierLoading}}
      onCancel={onCloseHandler}
      title={t('changeCourier')}
    >
      <Form
        name="basic"
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        form={form}
      >
        <Row>
          <Col span={24}>
            <FormItem
              label={t('orderNo')}
              labelAlign="left"
              name="orderId"
              initialValue={id ? id : null}
            >
              <Input disabled />
            </FormItem>
          </Col>
          <Col span={24}>
            <Form.Item
              label={t('routeCourierManagement.targetCourier')}
              labelAlign="left"
              name="courierId"
              rules={[
                {
                  required: true,
                  message: t('alert.fillField'),
                },
              ]}
            >
              <Select
                className="fullWidth"
                showSearch
                filterOption={true}
                optionFilterProp="children"
                placeholder="Dağıtıcı seçiniz"
                loading={getCourierLoading}
              >
                {couriers &&
                  couriers.map((courier) => (
                    <Option key={courier.id} value={courier.id}>
                      {courier.fullName}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>

    </Modal>
  );
};

export default ChangeOrderCourier;
